import { render, staticRenderFns } from "./WarehouseInitialStateTable.vue?vue&type=template&id=fc24c21c&scoped=true"
import script from "./WarehouseInitialStateTable.vue?vue&type=script&lang=js"
export * from "./WarehouseInitialStateTable.vue?vue&type=script&lang=js"
import style0 from "./WarehouseInitialStateTable.vue?vue&type=style&index=0&id=fc24c21c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc24c21c",
  null
  
)

export default component.exports